// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    notifications: [],
    isConnected: false,
    error: null
  },
  reducers: {
    setNotifications: (state, action) => {
      state.notifications = action.payload
    },
    addNotification: (state, action) => {
      const notification = action.payload
      if (!notification || !notification.id) return
      
      const existingIndex = state.notifications.findIndex(n => n.id === notification.id)
      if (existingIndex !== -1) {
        // Update existing notification
        state.notifications[existingIndex] = { ...state.notifications[existingIndex], ...notification }
      } else {
        // Add new notification
        state.notifications.unshift(notification)
      }
    },
    updateNotification: (state, action) => {
      const { id, updates } = action.payload
      const notification = state.notifications.find(n => n.id === id)
      if (notification) {
        Object.assign(notification, updates)
      }
    },
    markNotificationsAsRead: (state, action) => {
      const notificationIds = action.payload
      state.notifications.forEach(notification => {
        if (notificationIds.includes(notification.id)) {
          notification.isRead = true
        }
      })
    },
    setConnectionStatus: (state, action) => {
      const { isConnected, error } = action.payload
      state.isConnected = isConnected
      state.error = error
    },
    clearError: (state) => {
      state.error = null
    }
  }
})

export const {
  setNotifications,
  addNotification,
  updateNotification,
  markNotificationsAsRead,
  setConnectionStatus,
  clearError
} = notificationsSlice.actions

export default notificationsSlice.reducer
